import React from "react";
import { Col, Row, Card, Icon, Statistic } from "antd";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import "./Overview.less";

const TopKeywordsOverview = ({ isLoading, overview }) => {
  return (
    <div className="top-keywords-overview split-grid-overview quarters">
      {!isLoading ? (
        <Row gutter={20}>
          <Col className="top-keywords-overview-box" span={6}>
            <Card>
              <Statistic
                title="Average position"
                value={overview && overview.avg_pos}
                precision={2}
                prefix={<Icon type="vertical-align-middle" />}
              />
            </Card>
          </Col>
          <Col className="top-keywords-overview-box" span={6}>
            <Card>
              <Statistic
                title="Increased"
                value={overview && overview.increased}
                precision={0}
                valueStyle={{ color: "#3f8600" }}
                prefix={<Icon type="arrow-up" />}
              />
            </Card>
          </Col>
          <Col className="top-keywords-overview-box" span={6}>
            <Card>
              <Statistic
                title="Unchanged"
                value={overview && overview.unchanged}
                precision={0}
                prefix={<Icon type="swap" />}
              />
            </Card>
          </Col>
          <Col className="top-keywords-overview-box" span={6}>
            <Card>
              <Statistic
                title="Dropped"
                value={overview && overview.dropped}
                precision={0}
                valueStyle={{ color: "#cf1322" }}
                prefix={<Icon type="arrow-up" />}
              />
            </Card>
          </Col>
        </Row>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};

export default TopKeywordsOverview;
